import React, { useEffect } from "react";
import WhatWeOffer from "../../components/about_page/what_we_offer/WhatWeOffer";
import WhyChooseUs from "../../components/about_page/why_choose_us/WhyChooseUs";
import VisionAndMission from "../../components/about_page/vision&mission/VisionAndMission";
import IntroSection from "../../components/about_page/HeroSection_AboutUs/IntroSection";
import ResearchMethodology from "../../components/about_page/RM/ResearchMethodology";
import FinalStatement from "../../components/about_page/final_statement/FinalStatement";
import ImageContainer from "../../components/about_page/image/ImageContainer";
import { useLocation } from "react-router-dom";
import ContactPopupForm from "../../components/common/ContactDialogBox/ContactPopUpForm";

const About = () => {


  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.scrollTo(0, 0); // Scrolls to top whenever pathname changes
    }
  }, [location]);

  return (
    <>
      <IntroSection/>
      <ContactPopupForm/>      
      <VisionAndMission/>
      <WhatWeOffer/>
      <ImageContainer/>
      <ResearchMethodology/>
      <WhyChooseUs/>
      <FinalStatement/>
    </>
  );
};

export default About;
